import React from 'react';
import './airdroploot.css';
import parachuteLeft from '../assets/parachute_left.png';
import parachuteRight from '../assets/parachute_right.png';
import diamond from '../assets/Diamond.png';
import hourglass from '../assets/Hourglass.png';

const AirdropLoot = () => (
  <div className="airdrop-page">
    <div className="airdrop-container">
      <div className="icon-wrapper">
        <img src={parachuteLeft} alt="Parachute Left" className="parachute left" />
        <img src={diamond} alt="Diamond" className="diamond" />
        <img src={parachuteRight} alt="Parachute Right" className="parachute right" />
      </div>

      {/* ✅ New Styled Heading & Text Block */}
      <div className="airdrop-highlight-box">
        <h1 className="airdrop-heading">🌟 Experience the Future of Crypto Trading</h1>
        <p className="airdrop-subline">
          <strong>💰 See</strong> <span className="highlight">Simulated Profits Within 24 Hours</span> – <br />
          <span className="highlight">Watch how your wallet could grow before you invest anything.</span>
        </p>
        <p className="exchange-rate-line">
          <span className="label">🔐 Unlock full access</span> to the VORTREX AI Bot
        </p>
      </div>

      {/* ✅ CTA Button / Banner */}
      <div className="presale-banner">
        <img src={hourglass} alt="Hourglass" />
        <span>Let the Bot Trade For You — Live & Automated</span>
      </div>
    </div>
  </div>
);

export default AirdropLoot;
